  // components/HealthAssessment/WelcomeScreen.jsx

  import React, { useEffect, useState } from 'react';
  // import { Link } from 'react-router-dom';
  import styles from './welcomeScreen.module.css';
  import { getConditions } from './GetConditons';
  import { ScreenHeaderDFO } from './SharedUI';

  const ChevronRight = () => (
    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 6l6 6-6 6" />
    </svg>
  );

  const LockIcon = () => (
    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M8 11V7a4 4 0 118 0v4" />
    </svg>
  );

  const MainLogo = () => (
    <div className='flex items-center gap-2'>
      <img
        src="https://fplogoimages.withfloats.com/actual/69307aedfe3cec81a85953aa.png"
        alt="Dada Gujar Hospital"
        className='h-12 md:h-14 w-auto'
      />
    </div>
  );

  const CheckIcon = () => (
    <svg fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
    </svg>
  );

  // const WelcomeScreen = ({ onStart, onBack }) => {

  //   const [selectedType, setSelectedType] = useState(null);
  //   const [showAll, setShowAll] = useState(false);

  //   const handleStart = () => {
  //     if (!selectedType) return;
  //     onStart(selectedType);
  //   };

  //   const [userData, setUserData] = useState({});
  //   useEffect(() => {
  //     const data = localStorage.getItem('patientPersona');
  //     if (data) {
  //       const parsed = JSON.parse(data);
  //       setUserData(parsed);
  //       // 🔥 Auto-detect and set current
  //     }
  //   }, []);
  //   const extractMinAge = (ageRange = "") => {
  //     return Number(ageRange.split("–")[0]);
  //   };
  //   const ageNumber = extractMinAge(userData?.age || userData?.ageGroup);

  //   const { conditionGroups } = getConditions(ageNumber, userData?.maritalStatus);
  //   const groupNames = conditionGroups.map((g) => g.group);
  //   const visibleAssessments = showAll ? groupNames : groupNames.slice(0, 6);
  //   const remainingCount = Math.max(0, groupNames.length - 6);
const WelcomeScreen = ({ onStart, onBack }) => {
  const [selectedType, setSelectedType] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const [conditionGroups, setConditionGroups] = useState([]);
  const [allConditions, setAllConditions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userData, setUserData] = useState({});

  const handleStart = () => {
    if (!selectedType) return;
    onStart(selectedType);
  };

  // Load persona from localStorage on mount
  useEffect(() => {
    const data = localStorage.getItem('patientPersona');
    if (data) {
      setUserData(JSON.parse(data));
    }
  }, []);

  const extractMinAge = (ageRange = "") => {
    return Number(String(ageRange).split("–")[0]);
  };
  const ageNumber = extractMinAge(userData?.age || userData?.ageGroup);
  const maritalStatus = userData?.maritalStatus;

  // Fetch conditions once we actually have an age to query with
  useEffect(() => {
    if (!ageNumber || Number.isNaN(ageNumber)) return; // userData hasn't loaded yet

    let cancelled = false;

    async function load() {
      setLoading(true);
      setError(null);
      try {
        const result = await getConditions(ageNumber, maritalStatus);
        if (!cancelled) {
          setConditionGroups(result.conditionGroups || []);
          setAllConditions(result.allConditions || []);
        }
      } catch (e) {
        if (!cancelled) setError(e.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => { cancelled = true; };
  }, [ageNumber, maritalStatus]);

  const groupNames = conditionGroups.map((g) => g.group);
  const visibleAssessments = showAll ? groupNames : groupNames.slice(0, 6);
  const remainingCount = Math.max(0, groupNames.length - 6);

    return (
      <div className={styles.welcomeScreen}>
        <div style={{ paddingLeft: "20px", paddingRight: "20px", paddingTop: "20px" }}>
          <ScreenHeaderDFO />
        </div>
        {/* BODY */}
        <div className={styles.welcomeBody}>

          <img
            src="/images/menopause-nobg.png"
            alt="Welcome Illustration"
            className={styles.welcomeIllustration}
          />

          <h1 className={`ava-heading-md ${styles.welcomeTitle}`}>
            Women's Health Assessment
          </h1>

          <p className={`ava-text-xs ${styles.welcomeDesc}`}>
            Select the assessment that best matches your concern.
            Get personalized insights, risk screening, and care guidance.
          </p>

          {/* ASSESSMENT GRID */}
          <div className={styles.assessmentWrapper}>

            <p className={styles.assessmentHeading}>
              Choose your assessment type
            </p>

            <div className={styles.assessmentTypeGrid}>

              {visibleAssessments.map((type, index) => (

                <button
                  key={`${type}-${index}`}
                  className={`${styles.assessmentTypeCard} ${selectedType === type ? styles.assessmentTypeCardSelected : ''}`}
                  onClick={() => setSelectedType(type)}
                >

                  {selectedType === type && (
                    <span className={styles.assessmentTypeCardCheck}>
                      <CheckIcon />
                    </span>
                  )}

                  {/* {type.icon && (
                    <span style={{ fontSize: 18, lineHeight: 1 }}>{type.icon}</span>
                  )} */}
                  <span className={styles.assessmentTypeLabel}>
                    {type}
                  </span>
                </button>

              ))}

            </div>

            {/* VIEW MORE */}
            {groupNames.length > 6 && (

              <button
                type="button"
                className={styles.viewMoreBtn}
                onClick={() => setShowAll(!showAll)}
              >
                {showAll
                  ? "View Less"
                  : `View More (${remainingCount})`}
              </button>

            )}

          </div>

          {/* FEATURES */}
          <div className={styles.featureList}>

            <div className={styles.featureItem}>

              <div className={styles.featureIcon}>
                <svg fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"
                  />
                </svg>
              </div>

              <div className={`ava-text-body ${styles.featureText}`}>
                <strong>Private & Secure</strong>
                <span>Your data is confidential</span>
              </div>

            </div>

            <div className={styles.featureItem}>

              <div className={styles.featureIcon}>
                <svg fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>

              <div className={`ava-text-body ${styles.featureText}`}>
                <strong>5–7 Minutes</strong>
                <span>Simple guided assessment</span>
              </div>

            </div>

            <div className={styles.featureItem}>

              <div className={styles.featureIcon}>
                <svg fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.562.562 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"
                  />
                </svg>
              </div>

              <div className={`ava-text-body ${styles.featureText}`}>
                <strong>Personalized Results</strong>
                <span>Insights & next steps</span>
              </div>

            </div>

          </div>

        </div>

        {/* FOOTER */}
        <div className={styles.welcomeFooter}>

          <button
            className='btn-primary'
            onClick={handleStart}
            disabled={!selectedType}
            style={{
              opacity: selectedType ? 1 : 0.5,
              cursor: selectedType ? 'pointer' : 'not-allowed',
            }}
          >
            Start Assessment <ChevronRight />
          </button>

          <div className={`ava-text-caption ${styles.trustBadge}`}>
            <LockIcon/>
            Your health. Our priority.
          </div>
        </div>
      </div>
    );
  };

  export default WelcomeScreen;
